import {ReactNode} from "react";
import {Control, FieldPath, FieldValues} from "react-hook-form";
import {
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@root/server/client/esweb/components/ui/form.tsx";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@root/server/client/esweb/components/ui/select.tsx"

interface FormSelectProps<T extends FieldValues> {
    control: Control<T> | Control<any>;
    name: FieldPath<T>;
    label?: string;
    description?: string;
    placeholder?: string;
    options: { label: ReactNode; value: string; disabled?: boolean }[];
}

export const FormSelect = <T extends FieldValues>({
                                                      control,
                                                      name,
                                                      label,
                                                      description,
                                                      placeholder,
                                                      options,
                                                  }: FormSelectProps<T>) => {
    return (
        <FormField
            control={control as Control<T>}
            name={name}
            render={({ field }) => (
                <FormItem>
                    {label && <FormLabel>{label}</FormLabel>}
                    <Select name={name} onValueChange={field.onChange} defaultValue={field.value} value={field.value}>
                        <FormControl>
                            <SelectTrigger>
                                <SelectValue placeholder={placeholder} />
                            </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                            {options.map((option) => (
                                <SelectItem key={option.value} value={option.value} disabled={option.disabled}>
                                    {option.label}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                    {description && <FormDescription>{description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
};
